import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Modules, Usecases } from '../core'

import RegisteredCard from '../components/screens/RegisteredCard'

export default function RegisteredCardContainer() {
  const card = useSelector((state: Modules.AppState) => state.card)
  const dispatch = useDispatch()
  const actions = React.useMemo(
    () => ({
      fetchRegisteredCard() {
        const reloder = () => {
          dispatch(Usecases.Card.fetchRegisteredCard(reloder))
        }
        dispatch(Modules.Card.clearCard())
        dispatch(Usecases.Card.fetchRegisteredCard(reloder))
      },
      deleteRegisteredCard(showConfirmedModal: () => void) {
        dispatch(Usecases.Card.deleteRegisteredCard(showConfirmedModal))
      },
      clearScreenEmbeddedErrorAlert() {
        dispatch(Modules.ErrorModule.clearError())
      },
    }),
    [dispatch],
  )

  return <RegisteredCard card={card} actions={actions} />
}
